import moment from 'jalali-moment';

function isInList(list, id, idFieldKey) {
  let x = list.find((item) => {
    return item[idFieldKey] === id;
  });
  if (x == null)
    return false;
  else
    return true;
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));

};

export const correct_YeKe_Number = (text) => {
  if (text != null) {
    text = text.replace("ي", "ی").replace("ك", "ک");
  }
  return text;
};

export const findKey = (list, key) => {
  let result = undefined;

  list.forEach((item) => {
    if (item.key === key) {
      result = item;
    }
  });

  return result;
};

export const clone = (obj) => {
  let copy;
  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) return obj;
  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }
  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (let i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (let attr in obj) {
      let hasProperty = Object.prototype.hasOwnProperty.call(obj, attr);
      // if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      if (hasProperty) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }
  throw new Error("Unable to copy obj! Its type isn't supported.");
};

export const cloneList = (list) => {
  let clonedList = [];
  for (let i = 0, len = list.length; i < len; i++) {
    let item = clone(list[i]);
    clonedList.push(item);
  }
  return clonedList;
};

export const getRandomRuntimeId = () => {
  let min = Math.ceil(1000);
  let max = Math.floor(99999999);
  return Math.floor(Math.random() * (max - min)) + min;
};

export default {
  isInList,
  getParameterByName,
  correct_YeKe_Number,
  findKey,
  clone,
  cloneList,
  getRandomRuntimeId,
  moment
};


/*
        // let todayJalali = moment().locale('fa').format('YYYY/M/D');
        // console.log('today: ', todayJalali);
        // let x = moment.from('1367/11/04', 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD'); // 1989/01/24
        // let y = moment('1989/01/24', 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'); // 1367/11/04
        console.log(myDate);
        let y = this.$tools.moment(new Date(), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'); // 1367/11/04
        let x = this.$tools.moment(myDate, 'jYYYY/jM/jD HH:mm:ss').format('YYYY/M/D HH:mm:ss');
        let z = this.$tools.moment(myDate, 'YYYY/M/D HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
* */